<template>
  <div class="header-bar" v-if="!notDisplay">
    <div class="content">
      <logo :logo="logo" :inputStyle="{width:'10.65vw'}"></logo>
      <div class="links">
        <bar_link v-for="l in links" :key="l.text" :link="l" :class="{selected: $route.name == l.link.name }" ></bar_link>
      </div>
      <split_bar :inputStyle="splitStyle"></split_bar>

      <!-- <div class="version">
           <bar_link :link="keyVer" ></bar_link>
           </div> -->
      <!-- <split_bar :inputStyle="splitStyle"></split_bar> -->
      <div class="user" v-if="user">
        <!-- <div class="name">{{user.name}}</div> -->
        <bar_link :link="keyUser"></bar_link>
      </div>
      <div class="login" v-else>
        <bar_link :link="keyLogin" @click.native="commitRoute"></bar_link>
        <bar_link :link="keyRegister" :inputStyle="regStyle"></bar_link>
      </div>
    </div>
  </div>
</template>

<script>
 import Logo from '@/components/Logo.vue';
 import Link from '@/components/Link.vue';
 import SplitBar from '@/components/SplitBar.vue';
 export default {
   name: 'HeaderBar',
   methods: {
     commitRoute() {
       this.$store.commit('SET_REDIRECT', this.$router.currentRoute.fullPath)
     }
   },
   computed:  {
     notDisplay() {
       return this.$store.state.noHeader
     },
     user() {
       return this.$store.state.auth.user
     },
     splitStyle () {
       return {
         width: '1px',
         height: '0.9vw',
         margin: '0vw 2.3vw',
         'background-color': 'var(--grey)'
       }
     },
     regStyle () {
       return {
         'background-color': 'var(--blue)',
         width: this.$store.state.mediaPhone? '9vw':'5.6vw',
         height: '2.4vw',
         'border-radius': '1.2vw',
       }
     },
    logo () {
       return this.$store.state.logo.main
     },
    procedure() {
      return this.$store.state.procedure
    },
     links() {
       return this.$store.state.hbar.links.map((l) => {
         if(l.link.name === 'enroll') {
           if(this.user?.enrolled || this.procedure == 0) {
             l.disable = true
           } else {
             l.disable = false
           }
         }
         return l
       })
     },
     keyUser() {
       return {
         text: this.user.name,
         link: {name: 'User'}
       }
     },
     keyLogin(){
       return this.$store.state.hbar.login
     },
     keyRegister() {
       return this.$store.state.hbar.register
     },
     keyVer() {
       return this.$store.state.hbar.version
     }
   },
   mounted () {
     this.$http.get('/api/login/me')
         .then(res => {
           let user = res.data
           this.$store.commit('SET_USER', user);

           let classrooms = this.$http.get('/api/classroom');
           let gameState = this.$http.get('/api/user/game_state');
           /* this.$http.post('/api/user/update_junior_stat').catch(()=>{}); */
           Promise.all([classrooms, gameState])
                  .then(ress => {
                    let crs = ress[0].data
                    this.$store.commit("SET_CLASSROOMS", crs.classrooms)
                    this.$store.commit("SET_MY_CLASSROOM", crs.me_v2);
                    this.$store.commit("SET_GAME_STATE", ress[1].data)
               })
         })
         .catch(e => {
            this.$http.get('/api/classroom')
               .then(res2 => {
                 let data2 = res2.data
                 this.$store.commit("SET_CLASSROOMS", data2.classrooms)
               })
     })

   },
   components:{
     logo: Logo,
     bar_link: Link,
     split_bar: SplitBar
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .header-bar{
   display: flex;
   background-color: rgba(0, 0, 0, 0.3);
   position: fixed;
   top: 0;
   left: 0;
   height: 4vw;
   width: 100vw;
   align-items:center;
   justify-content: center;
 }
 .content{
   display: flex;
   align-items: center;
   justify-content: space-between;
   color: white;
 }
 .header-bar .links{
   display: flex;
   align-items: center;
   justify-content: space-between;
   width: 35vw;
   margin-left: 10vw;
 }
 .links>div{
   height: 4vw;
   box-sizing: border-box;
   border-top: 2px solid transparent;
   border-bottom: 2px solid transparent;
 }
 .header-bar .login{
   display: flex;
   align-items: center;
   justify-content: space-between;
   width: 9vw;
   margin-left: 0.2vw;
 }
 .header-bar .version{
 }
 .selected{
   border-bottom: 2px solid #2F4FFF !important;
 }

 @media (min-width: 320px) and (max-width: 480px) {
   .content{
     font-size: 5px;
   }
   .header-bar .links{
     width: 50vw;
     margin-left: 5vw;
   }
   .header-bar .login{
     width: 16vw;
   }

   .selected{
     border-bottom: 1px solid #2F4FFF !important;
   }
 }
</style>
